/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Role_Viewer_DescInputs */

const en_team_role_viewer_desc = /** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read-only access to dashboard stats.`)
};

const es_team_role_viewer_desc = /** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso de solo lectura a las estadísticas del panel.`)
};

const fr_team_role_viewer_desc = /** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès en lecture seule aux statistiques du tableau de bord.`)
};

const de_team_role_viewer_desc = /** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesezugriff auf Dashboard-Statistiken.`)
};

const id_team_role_viewer_desc = /** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses hanya-baca ke statistik dasbor.`)
};

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const ja_team_role_viewer_desc = en_team_role_viewer_desc;

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const zh_team_role_viewer_desc = en_team_role_viewer_desc;

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const ar_team_role_viewer_desc = en_team_role_viewer_desc;

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const it_team_role_viewer_desc = en_team_role_viewer_desc;

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const ru_team_role_viewer_desc = en_team_role_viewer_desc;

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const pt_team_role_viewer_desc = en_team_role_viewer_desc;

/** @type {(inputs: Team_Role_Viewer_DescInputs) => LocalizedString} */
const ko_team_role_viewer_desc = en_team_role_viewer_desc;

/**
* | output |
* | --- |
* | "Read-only access to dashboard stats." |
*
* @param {Team_Role_Viewer_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_role_viewer_desc = /** @type {((inputs?: Team_Role_Viewer_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Role_Viewer_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_role_viewer_desc(inputs)
	if (locale === "es") return es_team_role_viewer_desc(inputs)
	if (locale === "fr") return fr_team_role_viewer_desc(inputs)
	if (locale === "de") return de_team_role_viewer_desc(inputs)
	if (locale === "ja") return ja_team_role_viewer_desc(inputs)
	if (locale === "zh") return zh_team_role_viewer_desc(inputs)
	if (locale === "ar") return ar_team_role_viewer_desc(inputs)
	if (locale === "id") return id_team_role_viewer_desc(inputs)
	if (locale === "it") return it_team_role_viewer_desc(inputs)
	if (locale === "ru") return ru_team_role_viewer_desc(inputs)
	if (locale === "pt") return pt_team_role_viewer_desc(inputs)
	return ko_team_role_viewer_desc(inputs)
});